export default __webpack_public_path__ + "static/media/Swift Sensors.1c72b1b0.png";